import React from "react";
import AutoplayCarousel from "common/AutoplayCarousel";
import { socialProofImages } from "pages/Boost/utils";

const SocialProofImages = () => (
  <div className="py-8 bg-neutral-300">
    <AutoplayCarousel
      titleText="As mentioned in"
      duplicationFactor={3}
      totalWidthPreload={7752} // will need to change this if adding/removing image
      items={socialProofImages.map((item) => {
        return (
          <div className="" style={{ height: 30 }}>
            <img src={item.img} alt={item.alt} className="" />
          </div>
        );
      })}
      isPurpleText
    />
  </div>
);

export default SocialProofImages;